import { Box, FormHelperText } from "@mui/material"
import type { FC } from "react"

import { AerosDatePicker } from "@/components/UiKit"
import { useDraftDateRange } from "@/hooks/useDraftDateRange"

interface PayFileDateRangeFilterProps {
  scheduledPayDateFrom: string | undefined
  scheduledPayDateTo: string | undefined
  onRangeChange: (range: { from: string | undefined; to: string | undefined }) => void
}

export const PayFileDateRangeFilter: FC<PayFileDateRangeFilterProps> = ({
  scheduledPayDateFrom,
  scheduledPayDateTo,
  onRangeChange,
}) => {
  const { fromDraft, toDraft, isRangeInvalid, handleFromChange, handleToChange } = useDraftDateRange({
    from: scheduledPayDateFrom,
    to: scheduledPayDateTo,
    onRangeChange,
  })

  return (
    <Box className='flex-1 overflow-y-auto overflow-x-hidden px-8'>
      <Box className='flex flex-col gap-4 py-4'>
        <AerosDatePicker
          label='From'
          required
          value={fromDraft ?? null}
          onChange={handleFromChange}
          error={isRangeInvalid}
          data-testid='pay-file.filter-drawer.scheduled-pay-date-from-field'
        />
        <AerosDatePicker
          label='To'
          required
          value={toDraft ?? null}
          onChange={handleToChange}
          error={isRangeInvalid}
          data-testid='pay-file.filter-drawer.scheduled-pay-date-to-field'
        />
        {isRangeInvalid && <FormHelperText error>From date must be on or before To date</FormHelperText>}
      </Box>
    </Box>
  )
}
